import theme from "@/styles/novaTheme";
import { css } from "@emotion/react";

export const channelCartCss = css({
  display: "grid",
  gridTemplateColumns: "20% 80%",
  width: "100%",
  backgroundColor: theme.colors.white50,
  borderRadius: "0.7rem",
  padding: "1em",
  paddingLeft: "0",
  "div:first-of-type": {
    display: "flex",
    alignItems: "start",
    justifyContent: "center"
  },
  "> div": {
    "> p": {
      margin: "0.6em 0"
    },
    "> button": {
      borderRadius: "0.5em",
      width: "100%",
      maxWidth: "250px",
      marginTop: "0.3em",
      height: "3em"
    }
  }
});
